import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import DashboardNavbar from "../components/Navbar/navbar-dashboard";
import Footer from "../components/Footer/footer";
import './subscription.css';
import { FaCheckCircle } from 'react-icons/fa';

const SuccessPageMobile = () =>
{
  const location = useLocation();
  const [businessId, setBusinessId] = useState("");
  const [email, setEmail] = useState("");
  const [priceId, setPriceId] = useState("");
  const [title, setTitle] = useState("");
  const navigate = useNavigate();

  useEffect(() =>
  {
    const searchParams = new URLSearchParams(location.search);
    const businessIdParam = searchParams.get("businessId");
    const emailParam = searchParams.get("email");
    const priceIdParam = searchParams.get("priceId");
    const titleParam = searchParams.get("title");

    setBusinessId(businessIdParam);
    setEmail(emailParam);
    setPriceId(priceIdParam);
    setTitle(titleParam);
  }, [location]);

  return (
    <>
      <div className="success-page">
        <div className="success-content">
          <FaCheckCircle className="success-icon" />
          <h1>Subscription Successful!</h1>
          <p>Thank you for your purchase.</p>
          <div className="subscription-details">
            <p>You purchased the subscription: <strong>{title}</strong></p>
            <p><strong>Business ID:</strong> {businessId}</p>
            <p><strong>Email:</strong> {email}</p>
            <p><strong>Price ID:</strong> {priceId}</p>
            <p>&nbsp;</p>
            <div className="centered-button-container">
                <button
                    className="back-button-mobile"
                    onClick={() => window.location.href = 'buildstartapp://subscription/home'}
                >
                    Return to BuildStart App
                </button>
            </div>         
            <p>&nbsp;</p>
            <p>Or <a href="buildstartapp://subscription/home">tap here</a> to return to the BuildStart App now.</p>          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default SuccessPageMobile;